import { useNullableContext } from '~/common/contexts/nullableContext';
import { AppModule } from '../../constants';
import { ModuleScopeContext } from '../../ModuleScopeContext';

export const useModuleScopeRaw = (): AppModule =>
  useNullableContext(
    ModuleScopeContext,
    'useModuleScopeRaw must be used within a ModuleScopeProvider',
  );
